<div class="bg-white">
  <div class="card" style="border-bottom: none">
    <div class="card-header bg-info flex"
         style="height: 50px; align-items: center">
      <div id="toggle-linear"
           class="card-title card-padding c-white flex"
           style="align-items: center">
        <h2>{{'news.event.dialog.title' | translate}}</h2>
      </div>
    </div>
    <mat-horizontal-stepper [linear]="isLinear"
                            #stepper>
      <mat-step>
        <form>
          <ng-template matStepLabel>{{'news.event.dialog.first-step.title' | translate}}</ng-template>
          <div class="card-body padding-v-l">
            <div class="row expanded">
              <div class="small-4 columns">
                <mat-form-field>
                  <mat-select [(ngModel)]="categorySelected"
                              placeholder="{{'news.event.dialog.first-step.category' | translate}}"
                              name="Catégorie"
                              required>
                    <mat-option *ngFor="let category of categories | enumToArray"
                                [value]="category">
                      <span>
                        {{ category }}
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-select [(ngModel)]="themeSelected"
                              placeholder="{{'news.event.dialog.first-step.theme' | translate}}"
                              name="Thème"
                              required>
                    <mat-option *ngFor="let theme of themes | enumToArray"
                                [value]="theme">
                      <span>
                        {{ theme }}
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <input [(ngModel)]="title"
                         matInput
                         name="title"
                         placeholder="{{'news.event.dialog.first-step.event-title' | translate}}"
                         required>
                </mat-form-field>
                <mat-checkbox [(ngModel)]="isFocus" name="isImportant">Evénement important</mat-checkbox>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <textarea [(ngModel)]="description"
                            matInput
                            name="description"
                            placeholder="{{'news.event.dialog.first-step.description' | translate}}"
                            required>
                  </textarea>
                </mat-form-field>
              </div>
            </div>
            <div class="row expanded">
              <div class="small-4 columns">
                <mat-form-field>
                  <input [(ngModel)]="place"
                         matInput
                         name="place"
                         placeholder="{{'news.event.dialog.first-step.place' | translate}}"
                         required>
                </mat-form-field>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <input [matDatepicker]="startDatePicker"
                         [ngModel]="startDate"
                         (ngModelChange)="setDates($event)"
                         matInput
                         name="startDate"
                         placeholder="{{'news.event.dialog.first-step.start-date' | translate}}"
                         required>
                  <mat-datepicker-toggle [for]="startDatePicker"
                                         matSuffix>
                  </mat-datepicker-toggle>
                  <mat-datepicker #startDatePicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <input [matDatepicker]="endDatePicker"
                         [(ngModel)]="endDate"
                         matInput
                         name="endDate"
                         placeholder="{{'news.event.dialog.first-step.end-date' | translate}}">
                  <mat-datepicker-toggle [for]="endDatePicker"
                                         matSuffix>
                  </mat-datepicker-toggle>
                  <mat-datepicker #endDatePicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>
            </div>
            <div class="row expanded">
              <div class="small-4 columns">
                <mat-form-field>
                  <input [(ngModel)]="programLink"
                         matInput
                         name="programLink"
                         placeholder="{{'news.event.dialog.first-step.program-link' | translate}}"
                         required>
                </mat-form-field>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <input [(ngModel)]="subscriptionLink"
                         matInput
                         name="subscriptionLink"
                         placeholder="{{'news.event.dialog.first-step.subscription-link' | translate}}"
                         required>
                </mat-form-field>
              </div>
              <div class="small-4 columns">
                <mat-form-field>
                  <input [(ngModel)]="commercialLink"
                         matInput
                         name="commercialLink"
                         placeholder="{{'news.event.dialog.first-step.commercial-link' | translate}}"
                         required>
                </mat-form-field>
              </div>
            </div>
            <div class="row margin-t-l border-t">
            </div>
            <div class="small-2 columns margin-t-l">
              <button (click)="goToStep2(stepper)"
                      mat-button>
                {{'news.event.dialog.next' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <form>
          <ng-template matStepLabel>{{'news.event.dialog.second-step.title' | translate}}</ng-template>
          <div class="card-body padding-v-s">
            <div class="row expanded">
              <span style="font-size: 15px; font-weight: 900;">{{'news.event.dialog.second-step.can-subscribe' | translate}}</span>
            </div>
            <div class="row expanded margin-t-l">
              <div *ngFor="let solution of segmentationSolution"
                   class="small-3 columns">
                <mat-checkbox [disabled]="solution.canAdvertise"
                              [(ngModel)]="solution.canSubscribe"
                              name="subscribe-{{solution.value}}">
                  {{solution.value}}
                </mat-checkbox>
              </div>
              <div class="small-6 columns"></div>
            </div>
            <div class="row margin-t-l border-t">
            </div>
            <div class="row expanded margin-t-l">
              <span style="font-size: 15px; font-weight: 900;">{{'news.event.dialog.second-step.can-see-program' | translate}}</span>
            </div>
            <div class="row expanded">
              <div class="margin-t-l">
                <div *ngFor="let solution of segmentationSolution"
                     class="small-3 columns">
                  <mat-checkbox [disabled]="solution.canSubscribe"
                                [(ngModel)]="solution.canAdvertise"
                                name="advertise-{{solution.value}}">
                    {{solution.value}}
                  </mat-checkbox>
                </div>
                <div class="small-6 columns"></div>
              </div>
              <div class="small-4 columns">
              </div>
            </div>
            <div class="row margin-t-l border-t">
            </div>
            <div class="small-2 columns margin-t-l">
              <button mat-button
                      matStepperPrevious="">
                {{'news.event.dialog.return' | translate}}
              </button>
            </div>
            <div class="small-2 columns margin-t-l">
              <button mat-button
                      matStepperNext>
                {{'news.event.dialog.next' | translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <form>
          <ng-template matStepLabel>
            {{'news.event.dialog.third-step.title' | translate}}
          </ng-template>
          <div style="height: 215px; display: flex; align-items: center; justify-content: center; font-size: 1.8rem">
            {{'news.event.dialog.third-step.register-sentence' | translate}}
          </div>
          <div class="row margin-t-l border-t">
          </div>
          <div class="small-2 columns margin-t-l">
            <button mat-button
                    matStepperPrevious="">
              {{'news.event.dialog.return' | translate}}
            </button>
          </div>
          <div class="small-3 columns margin-t-l">
            <button *ngIf="!data"
                    (click)="saveEvent(stepper)"
                    mat-button>
              {{'news.event.dialog.third-step.register-action' | translate}}
            </button>
            <button *ngIf="data"
                    (click)="editEvent(stepper, data.event)"
                    mat-button>
              {{'news.event.dialog.third-step.register-action' | translate}}
            </button>
          </div>
        </form>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
